import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getAgencyAgentsByAPI, getAgencyProfileByAPI } from '@/api/agency';
import { getDefaultAgencyProfile } from '@/helpers/agencyProfileHelper';
import type { AgencyAgent, AgencyProfile } from '@/types-agency';
import { ApiCallStatus } from '@/types-agency';

export const useAgencyProfileStore = defineStore('agencyProfile', () => {
  const agencyProfile = ref<AgencyProfile>(getDefaultAgencyProfile());
  const agencyAgents = ref<AgencyAgent[]>([]);
  const profileApiStatus = ref(ApiCallStatus.READY);
  const agentsApiStatus = ref(ApiCallStatus.READY);

  const fetchAgencyProfile = async (): Promise<void> => {
    profileApiStatus.value = ApiCallStatus.IN_PROGRESS;
    try {
      agencyProfile.value = (await getAgencyProfileByAPI()) ?? getDefaultAgencyProfile();
      profileApiStatus.value = ApiCallStatus.SUCCESS;
    } catch (error) {
      profileApiStatus.value = ApiCallStatus.ERROR;
      throw error;
    }
  };

  const fetchAgencyAgents = async (): Promise<void> => {
    agentsApiStatus.value = ApiCallStatus.IN_PROGRESS;
    try {
      agencyAgents.value = await getAgencyAgentsByAPI();
      agentsApiStatus.value = ApiCallStatus.SUCCESS;
    } catch (error) {
      agentsApiStatus.value = ApiCallStatus.ERROR;
      throw error;
    }
  };

  return {
    agencyProfile,
    agencyAgents,
    profileApiStatus,
    agentsApiStatus,
    fetchAgencyProfile,
    fetchAgencyAgents,
  };
});
